module.exports = __webpack_public_path__ + "media/images/index/feature/top-coj-d-9b94762c0814f68fcf010125c3a11f7b.png";